<template>
  <div class="supplier-left-content card flex-column">
    <div class="content-item section flex-column">
      <base-section-title title="竞价须知" class="section-title" />
      <div class="content-wrap">
        <!--        <div class="no-content flex-center">暂无内容</div>-->
        <el-scrollbar>
          <div class="content">
            <compete-copywriter type="prerequisites" />
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="content-item section flex-column">
      <base-section-title title="注意事项" class="section-title" />
      <div class="content-wrap">
        <el-scrollbar>
          <div class="content">
            <compete-copywriter type="caveat" />
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import CompeteCopywriter from '@/components/copywriter/CompeteCopywriter'

export default {
  name: 'SupplierLeftContent',

  components: {
    BaseSectionTitle,
    CompeteCopywriter
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.supplier-left-content {
  flex: 1;

  .content-item {
    flex: 1;
    overflow: hidden;

    .content-wrap {
      margin: 0 pixel-to-rem($n: 20);
      flex: 1;
      overflow: hidden;

      .no-content {
        height: 100%;
        background-color: $grey-background-color;
        color: $second-text-color;
        font-size: pixel-to-rem($n: 22);
      }

      ::v-deep .el-scrollbar {
        height: 100%;
        background-color: $grey-background-color;

        .el-scrollbar__wrap {
          overflow-x: hidden !important;
        }
      }

      .content {
        padding: pixel-to-rem($n: 20);
        font-size: pixel-to-rem($n: 20);
      }
    }
  }
}
</style>
